export default "__VITE_ASSET__XxUUSFTX__"